module.exports = __webpack_public_path__ + "media/images/logo-980c67c92ba4e744eb90852321dc1238.svg";